import theme from "@/theme";

const PurchasedSvg = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 8V5C20 3.89543 19.1046 3 18 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H8"
      stroke={theme.palette.custom.mainBlue}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 17.5909V19C21 20.1046 20.1046 21 19 21H13C11.8954 21 11 20.1046 11 19V13C11 11.8954 11.8954 11 13 11H19C20.1046 11 21 11.8954 21 13V14.4091"
      stroke={theme.palette.custom.mainBlue}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0909 14.4102H21.5C21.7761 14.4102 22 14.634 22 14.9102V17.092C22 17.3681 21.7761 17.592 21.5 17.592H20.0909C19.669 17.592 19.2643 17.4244 18.966 17.126C18.6676 16.8277 18.5 16.423 18.5 16.0011V16.0011C18.5 15.1224 19.2123 14.4102 20.0909 14.4102V14.4102Z"
      stroke={theme.palette.custom.mainBlue}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 8H16"
      stroke={theme.palette.custom.mainBlue}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 12H8"
      stroke={theme.palette.custom.mainBlue}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 16H8"
      stroke={theme.palette.custom.mainBlue}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default PurchasedSvg;
